export default {
    printer: {icon: 'mdi-printer', color: 'pale-light-blue', effect: [
        {name: 'gallery_newStyle', type: 'keepUpgrade', value: true},
        {name: 'gallery_recycling', type: 'keepUpgrade', value: true},
        {name: 'sortWaste', type: 'galleryIdea', value: true}
    ]},
    lightbulb: {icon: 'mdi-lightbulb', color: 'pale-yellow', effect: [
        {name: 'gallery_epiphany', type: 'keepUpgrade', value: true},
        {name: 'galleryInspirationStart', type: 'base', value: 1}
    ]},
    oldTV: {icon: 'mdi-television-classic', color: 'brown', effect: [
        {name: 'advertise', type: 'galleryIdea', value: true}
    ]},
    worryingMail: {icon: 'mdi-email-alert', color: 'red', effect: [
        {name: 'beImpatient', type: 'galleryIdea', value: true}
    ]},
    redBalloon: {icon: 'mdi-balloon', color: 'red', effect: [
        {name: 'gallery_redPower', type: 'keepUpgrade', value: true},
        {name: 'gallery_redConversion', type: 'keepUpgrade', value: true}
    ]},
    sackOfGold: {icon: 'mdi-sack', color: 'amber', effect: [
        {name: 'observeRainbow', type: 'galleryIdea', value: true}
    ]},
    shredder: {icon: 'mdi-shredder', color: 'pale-purple', effect: [
        {name: 'gallery_filters', type: 'keepUpgrade', value: true},
        {name: 'gallery_trashCan', type: 'keepUpgrade', value: true},
        {name: 'buildComposter', type: 'galleryIdea', value: true}
    ]},
    redprint: {icon: 'mdi-script-text', color: 'red', effect: [
        {name: 'gallery_redRage', type: 'keepUpgrade', value: true},
        {name: 'buildRedReservoir', type: 'galleryIdea', value: true}
    ]},
    orangeBalloon: {icon: 'mdi-balloon', color: 'orange', effect: [
        {name: 'gallery_orangePower', type: 'keepUpgrade', value: true},
        {name: 'gallery_orangeConversion', type: 'keepUpgrade', value: true}
    ]},
    creditCard: {icon: 'mdi-credit-card', color: 'pale-green', effect: [
        {name: 'orderMassiveSafe', type: 'galleryIdea', value: true}
    ]},
    simpleCalculator: {icon: 'mdi-calculator', color: 'pale-orange', effect: [
        {name: 'calculateOdds', type: 'galleryIdea', value: true}
    ]},
    orangeprint: {icon: 'mdi-script-text', color: 'orange', effect: [
        {name: 'gallery_redLuck', type: 'keepUpgrade', value: true},
        {name: 'buildOrangeReservoir', type: 'galleryIdea', value: true}
    ]},
    yellowBalloon: {icon: 'mdi-balloon', color: 'yellow', effect: [
        {name: 'gallery_yellowPower', type: 'keepUpgrade', value: true},
        {name: 'gallery_yellowConversion', type: 'keepUpgrade', value: true}
    ]},
    fishbowl: {icon: 'mdi-fishbowl', color: 'pale-blue', effect: [
        {name: 'galleryShapeGain', type: 'mult', value: 1.5},
        {name: 'beExcited', type: 'galleryIdea', value: true}
    ]},
    pencil: {icon: 'mdi-lead-pencil', color: 'pale-red', effect: [
        {name: 'galleryShapeGain', type: 'mult', value: 1.5},
        {name: 'buyPen', type: 'galleryIdea', value: true}
    ]},
    smallBrush: {icon: 'mdi-brush', color: 'pale-pink', effect: [
        {name: 'galleryShapeGain', type: 'mult', value: 1.5},
        {name: 'buyBrush', type: 'galleryIdea', value: true}
    ]},
    strangePills: {icon: 'mdi-pill-multiple', color: 'pale-red', effect: [
        {name: 'galleryShapeGain', type: 'mult', value: 1.5},
        {name: 'hyperfocus', type: 'galleryIdea', value: true}
    ]},
    strangeScroll: {icon: 'mdi-script-text', color: 'dark-grey', effect: [
        {name: 'beMysterious', type: 'galleryIdea', value: true}
    ]},
    printingPress: {icon: 'mdi-arrow-collapse-vertical', color: 'brown', effect: [
        {name: 'currencyGalleryCashGain', type: 'mult', value: 1.5},
        {name: 'printNewspaper', type: 'galleryIdea', value: true}
    ]},
    yellowprint: {icon: 'mdi-script-text', color: 'yellow', effect: [
        {name: 'gallery_orangeLuck', type: 'keepUpgrade', value: true},
        {name: 'buildYellowReservoir', type: 'galleryIdea', value: true}
    ]},
    greenBalloon: {icon: 'mdi-balloon', color: 'green', effect: [
        {name: 'gallery_greenPower', type: 'keepUpgrade', value: true},
        {name: 'gallery_greenConversion', type: 'keepUpgrade', value: true}
    ]},
    woodenHanger: {icon: 'mdi-hanger', color: 'wooden', effect: [
        {name: 'paintFaster', type: 'galleryIdea', value: true}
    ]},
    bedsheet: {icon: 'mdi-bed-empty', color: 'pale-red', effect: [
        {name: 'expandCanvas', type: 'galleryIdea', value: true}
    ]},
    imageAlbum: {icon: 'mdi-image-album', color: 'orange-red', effect: [
        {name: 'gallery_paintDrumStorage', type: 'keepUpgrade', value: true},
        {name: 'paintForFun', type: 'galleryIdea', value: true}
    ]},
    greenprint: {icon: 'mdi-script-text', color: 'green', effect: [
        {name: 'gallery_yellowLuck', type: 'keepUpgrade', value: true},
        {name: 'buildGreenReservoir', type: 'galleryIdea', value: true}
    ]},
    blueBalloon: {icon: 'mdi-balloon', color: 'blue', effect: [
        {name: 'gallery_bluePower', type: 'keepUpgrade', value: true},
        {name: 'gallery_blueConversion', type: 'keepUpgrade', value: true}
    ]},
    blueprint: {icon: 'mdi-script-text', color: 'blue', effect: [
        {name: 'gallery_greenLuck', type: 'keepUpgrade', value: true},
        {name: 'buildBlueReservoir', type: 'galleryIdea', value: true}
    ]},
    purpleBalloon: {icon: 'mdi-balloon', color: 'purple', effect: [
        {name: 'gallery_purplePower', type: 'keepUpgrade', value: true},
        {name: 'gallery_purpleConversion', type: 'keepUpgrade', value: true}
    ]},
}
